var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasOpened)?_c('div',{staticClass:"smart-banner"},[_c('div',{staticClass:"close-button",on:{"click":function () { _vm.hasOpened = !_vm.hasOpened }}},[_c('v-btn',{attrs:{"rounded":""}},[_c('v-icon',[_vm._v("close")])],1)],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }